module.exports = __webpack_public_path__ + "img/silver1.f3cfc878.png";